module.exports = __webpack_public_path__ + "static/media/real2.a68a82b5.jpg";